<script lang="ts">
	import { Button } from '$lib/components/ui/button';
	import { cn } from '$lib/utils';
	import { BadgeCheckIcon, CheckCircle2Icon } from 'lucide-svelte';
	import * as HoverCard from '$lib/components/ui/hover-card';
	import { dev } from '$app/environment';

	export let title: string = 'Title';
	export let euroPricePerMonth: number = 0;
	export let description =
		'Together with Meeko, you can setup learning objectives for you to focus on any given';
	export let interval = 'MONTHLY';
	export let plan: string | null = null;
	export let features: string[] = [];
	export let superFeature: string = '';
	export let isCurrentPlan: boolean = false;
	export const ctaText: string = 'Get started for free';
	export const disabled: boolean = false;

	let className = '';

	export { className as class };
</script>

<div
	class={cn(
		'relative flex h-[520px] flex-col gap-6 overflow-hidden rounded-2xl border border-darkTertiary bg-darkSecondary p-8 shadow-lg transition-colors hover:border-darkQuaternary',
		className
	)}
>
	{#if euroPricePerMonth !== 0}
		<div class="card-spotlight -right-48 -top-48 z-0 h-96" />
	{/if}
	<div class="flex flex-col gap-2">
		<h3 class="text-xl font-normal">{title}</h3>
		<div class="flex flex-row items-center justify-start gap-2">
			<p
				class={cn('text-2xl font-normal', title === 'Meeko+' ? 'text-purple-500' : 'text-primary')}
			>
				€{euroPricePerMonth} / month
				{#if euroPricePerMonth !== 0 && interval === 'YEARLY'}*{/if}
			</p>
			{#if euroPricePerMonth === 0}
				<span class="text-md font-light text-lightQuaternary">(Free)</span>
			{/if}
		</div>
		<p class="mt-2 text-sm font-light text-lightQuaternary">
			{description}
		</p>
	</div>
	{#if isCurrentPlan}
		<HoverCard.Root>
			<HoverCard.Trigger>
				<Button
					class="w-full gap-2 border-darkQuaternary bg-darkSecondary text-lightTertiary"
					disabled
					variant="outline"
				>
					<BadgeCheckIcon class="h-5 w-5" />
					Your current plan
				</Button>
			</HoverCard.Trigger>
			<HoverCard.Content class="text-sm"
				>To handle your subscription, please visit <span class="text-lightPrimary"
					>Manage subscription</span
				> via your account (top right).
			</HoverCard.Content>
		</HoverCard.Root>
	{:else if euroPricePerMonth === 0}
		<Button
			disabled
			class={cn(
				'relative w-full',
				plan === 'PREMIUM'
					? 'border-primary bg-primary hover:border-purple-500 hover:bg-purple-500'
					: 'border-darkQuaternary'
			)}
			variant={plan === 'PREMIUM' ? 'default' : 'outline'}
			><enhanced:img
				src="/static/images/star.png"
				alt="meeko.ai"
				class="absolute right-0 top-0 z-40 h-9 w-auto opacity-30"
			/>Try Meeko for free</Button
		>
	{/if}
	{#if features?.length > 0}
		<ul class="flex flex-col gap-4">
			{#each features as feature}
				<li class="flex flex-row items-center gap-4 text-sm font-light text-lightSecondary">
					<CheckCircle2Icon class="h-6 min-h-6 w-6 min-w-6" />
					<span class="mt-0.5">{feature}</span>
				</li>
			{/each}
			{#if superFeature}
				<li
					class={cn(
						'flex flex-row items-center gap-4 text-sm font-normal',
						plan == 'PREMIUM' ? 'text-primary' : 'text-purple-500'
					)}
				>
					<CheckCircle2Icon class="h-6 min-h-6 w-6 min-w-6" />{superFeature}
				</li>
			{/if}
		</ul>
	{/if}
	{#if interval === 'YEARLY'}
		<span class="absolute bottom-6 text-xs font-light text-neutral-600">*Billed yearly</span>
	{/if}
</div>
